import apiClient from "./apiClient";

export const getSchoolTeachers = async (userId) => {
  const response = await apiClient.get("/Users/GetSchoolTeachers", {
    params: { userId },
  });

  return response.data;
};
